<template>
  <div class="PlazaDrop" @mouseover="mouseover" @mouseout="mouseout">
    <slot name="title">{{title}}</slot>
    <transition name="drop">
      <div class="drop" v-show="bol">
        <div class="drop_list">
          <div class="drop_list_item ellipsis"
          v-for="item in list" :key="item.activityId"
          @click="dropBtn(item)">
            {{item.squareName}}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      disabledBol: false,
      margin: 0,
      bol: false,
      list: [],
      timer: null    // 定时器
    }
  },
  props: {
    title: {}
  },
  methods: {
    // 点击下拉列表
    dropBtn (item) {
      // 去活动广场
      this.toPage()
      let data = {
        activityId: item.activityId,
        squareName: item.squareName
      }
      this.$utils.sessionCache(`activity${item.activityId}`, JSON.stringify(data))
      this.$router.push({
        path: '/EventPlaza/home',
        query: {
          activityId: item.activityId
        }
      })
    },
    // 获取广场列表
    getList () {
      this.$getCommon('PLAZA_ACTIVITY_LIST', {}).then(({ data }) => {
        this.list = data || []
      })
    },
    // 鼠标移进来了
    mouseover () {
      if (this.disabledBol) return
      this.bol = true
      clearTimeout(this.timer)
    },
    // 鼠标出来了
    mouseout () {
      this.timer = setTimeout(() => {
        this.bol = false
        clearTimeout(this.timer)
      }, 300)
    },
    toPage () {
      this.disabledBol = true
      this.bol = false
      // 兼容不重复拉取
      setTimeout(() => {
        this.disabledBol = false
      }, 400)
    }
  },
  watch: {
    'bol' () {
      if (this.list.length === 0) {
        this.getList()
      }
    }
  },
  destroyed () {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.PlazaDrop{
  position: relative;
  .drop{
    position: absolute;
    left: -115px;
    width: 286px;
    box-sizing: border-box;
    padding: 10px;
    background: #fff;
    box-shadow: 0 8px 16px 0 rgba(222,224,227,0.50);
    border-radius: 0 0 8px 8px;
    .drop_list{
      .drop_list_item{
        line-height: 36px;
        font-size: 13px;
        padding: 0 16px;
        border-radius: 2px;
      }
      .drop_list_item:hover{
        color: #296BFF;
        background: #F6F9FD;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/plaza-drop.vue